import defaultColor from "@/components/color";

const dataStr = JSON.stringify([
    {
        group:'1990年',
        data:[
            [28604, 77, 170, 'Australia'],
            [31163, 77.4, 276, 'Canada'],
            [1516, 68, 153, 'China'],
            [13670, 74.7, 105, 'Cuba'],
            [28599, 75, 498, 'Finland'],
            [29476, 77.1, 569, 'France'],
            [31476, 75.4, 789, 'Germany'],
            [28666, 78.1, 25, 'Iceland'],
            [1777, 57.7, 706, 'India'],
            [29550, 79.1, 122, 'Japan'],
            [2076, 67.9, 201, 'North Korea'],
            [12087, 72, 429, 'South Korea'],
            [24021, 75.4, 33, 'New Zealand'],
            [43296, 76.8, 42, 'Norway'],
            [10088, 70.8, 381, 'Poland'],
            [19349, 69.6, 475, 'Russia'],
            [10670, 67.3, 539, 'Turkey'],
            [26424, 75.7, 571, 'United Kingdom'],
            [37062, 75.4, 528, 'United States']
        ]
    },{
        group:'2015年',
        data:[
            [44056, 81.8, 239, 'Australia'],
            [43294, 81.7, 359, 'Canada'],
            [13334, 76.9, 137, 'China'],
            [21291, 78.5, 113, 'Cuba'],
            [38923, 80.8, 55, 'Finland'],
            [37599, 81.9, 243, 'France'],
            [44053, 81.1, 306, 'Germany'],
            [42182, 82.8, 32, 'Iceland'],
            [5903, 66.8, 131, 'India'],
            [36162, 83.5, 126, 'Japan'],
            [1390, 71.4, 251, 'North Korea'],
            [34644, 80.7, 50, 'South Korea'],
            [34186, 80.6, 45, 'New Zealand'],
            [64304, 81.6, 52, 'Norway'],
            [24787, 77.3, 386, 'Poland'],
            [23038, 73.13, 143, 'Russia'],
            [19360, 76.5, 78, 'Turkey'],
            [38225, 81.4, 64, 'United Kingdom'],
            [53354, 79.1, 321, 'United States']
        ]
    }
])

export default {
    cptDataForm:{
        dataSource: 1, pollTime: 0, dataText: dataStr,
    },
    attribute:{
        scale:0.1,
        color:defaultColor,
        title: {
            text: '按国家分列的预期寿命和GDP',
            top:'top',
            left: '10',
            textStyle:{
                color: '#ddd'
            }
        },

        legend: {
            left: 'right',
            top: '10',
            textStyle: {
                color:'#6aa9e4',
                fontSize: 13
            }
        },
        grid:{
            x:10,y:30,x2:23,y2:30,
        },
        // grid: {
        //     left: '8%',
        //     top: '12%',
        //     bottom: 10,
        //     containLabel: true
        // },
        xAxis: {
            axisLabel:{
                show: true,
                color: '#6aa9e4'
            },
            axisLine:{
                show: true,
                lineStyle: {
                    color: '#02438e'
                }
            },
            axisTick:{//x轴刻度线
                show: false
            },
            splitLine: {//网格线
                show: true,
                lineStyle: {
                    type: 'dashed',
                    color: '#14477e',
                }
            }
        },
        yAxis: {
            type: 'value',
            axisLabel:{
                show: true,
                color: '#6aa9e4'
            },
            axisLine:{
                show: false,
                lineStyle:{
                    color: '#eee'
                }
            },
            axisTick:{//y轴刻度线
                show: false
            },
            splitLine: {//网格线
                show: true,
                lineStyle: {
                    type: 'dashed',
                    color: '#14477e',
                }
            },
            scale: true
        },
        xTip:'<br/>GDP：',
        yTip:'<br/>寿命：',
        areaTip:'<br/>人口：',
        tooltip: {
            trigger: 'item',
            backgroundColor: 'rgba(0,0,0,0.5)',
            textStyle: {
                color: "#fff",
            },
            axisPointer: {            // 坐标轴指示器，坐标轴触发有效
                type: 'shadow',       // 默认为直线，可选为：'line' | 'shadow'
            }
        },
        dataZoom: {show: false,height:15},
        cptTableData: [{ "name": "分组", "value": "", "namekey": "group" },
        { "name": "指标", "value": "", "namekey": "value" }]
    },
}
